import { render, staticRenderFns } from "./ModalBackofficeNacionalidade.vue?vue&type=template&id=866bac8c&scoped=true"
import script from "./ModalBackofficeNacionalidade.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeNacionalidade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866bac8c",
  null
  
)

export default component.exports